/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InaxConfigComponent } from './components/inaxConfig.component';
import { InaxConfigUiResourceManager } from './resources/resource.service';
import { CommonUiModule } from '../../commonUi/src/commonUi.module';
import { TranslateModule } from '../../translate/src/translate.module';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    imports:
    [
        CommonUiModule,
        FormsModule,
        TranslateModule,
        BrowserModule
    ],
    exports:
    [
        InaxConfigComponent
    ],
    declarations:
    [
        InaxConfigComponent
    ],
    providers:
    [
        InaxConfigUiResourceManager, { provide: 'Window', useValue: window }
    ],
    bootstrap: []
})

export class InaxConfigUiModule {
    //Resource manager adds the translations to the translationservice
    constructor(private _resourceManager: InaxConfigUiResourceManager ) {}
}